/**
 *
 * EmailRecipientTypesPicker(multi)
 *
 */

import * as React from 'react';
import { httpClient } from 'api/HttpClient';
import { Entity } from 'types/common';
import { Condition, ODataOperators } from 'api/odata/ODataFilter';
import { ERTBaseURLMultiPicker } from './ERTBaseURLMultiPicker';

export interface EmailRecipientTypesPickerProps {
  value?: Entity<number>[] | null;
  name?: string;
  error?: boolean;
  label?: string;
  className?: string | undefined;
  helperText?: string;
  placeholder?: string | undefined;
  // value: Entity<number>[];
  defaultValue?: Entity<number>[];
  onChange: (value: Entity<number>[]) => void;
  onBlur?: React.FocusEventHandler<HTMLDivElement>;
  variant?: 'standard' | 'filled' | 'outlined';
  info?: string;
  id?: string;
  required?: boolean;
  fullWidth?: boolean;
}

const url = '/api/odata/v4/EmailRecipientTypesFilter';

export const initEmailRecipientTypesData = (
  initval: string | undefined,
): Promise<Entity<number>[]> => {
  if (initval === undefined) {
    return new Promise<Entity<number>[]>((resolve, reject) => {
      resolve([] as Entity<number>[]);
    });
  } else {
    const id = parseInt(initval);
    const params: {
      $orderby: string;
      $filter?: string;
      $select: string;
      $top: number;
      $skip: number;
    } = {
      $orderby: 'Name asc',
      $filter: new Condition('Id', ODataOperators.Equals, id).toString(),
      $select: 'Id,Name',
      $skip: 0,
      $top: 1,
    };
    return httpClient
      .get(url, params)
      .then(response => response.value as Entity<number>[]);
  }
};

export function EmailRecipientTypesPicker({
  label,
  defaultValue,
  placeholder,
  className,
  required,
  helperText,
  onChange,
  variant,
  info,
  id,
  value,
  ...props
}: EmailRecipientTypesPickerProps) {
  return (
    <ERTBaseURLMultiPicker
      url={url}
      queryfilter={``}
      variant={variant}
      onChange={onChange}
      info={info}
      id={id || 'users-filter'}
      helperText={helperText}
      required={required}
      className={className}
      onBlur={props.onBlur}
      placeholder={placeholder}
      defaultValue={defaultValue ?? []}
      label={label}
      value={value ?? []}
      {...props}
      error={props.error}
    />
  );
}
